import React, { useEffect, useState } from 'react';
import { Icon } from 'semantic-ui-react';
import FeatherIcon from "feather-icons-react";
import './style.scss';

export const Toggle = (params) => {

  const [check, setCheck] = useState(false)

  useEffect(() => {
    if (params?.disabled) {
      setCheck(false)
    }
  }, [params?.disabled])

  return (
    <div className={`form-toggle-container ${params.className || ''}`} >
    <label className={`form-toggle-switch m-0`} htmlFor={params.id}>
        <input 
            type="checkbox" 
            className='form-toggle-input' 
            // disabled={params.disabled} 
            id={params.id} 
            key={params.id} 
            checked={check}
            onClick={(e) => { 
                setCheck((current) => !current)
                e.stopPropagation() 
            }}
            onChange={() => {}}
            ref={(ref) => params?.useRef ? params.useRef.current[params?.id || 'input'] = ref : null} 
        />
        <div className={`form-toggle-slider round ${params.disabled ? 'form-toggle-slider-disabled' : ''}`}></div>
    </label>
    </div>
  )
}